import { useRef, type ReactNode } from 'react';
import { useFocusTrap } from './useFocusTrap.js';

/** Modal dialog with the §6.5 contract: focus trap, Esc close, focus
 * restoration on unmount (PD-14). */
export function Modal({
  title,
  children,
  onClose,
}: {
  title: string;
  children: ReactNode;
  onClose: () => void;
}): ReactNode {
  const ref = useRef<HTMLDivElement>(null);
  useFocusTrap(ref, onClose);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal fade-up"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        ref={ref}
        onClick={(event) => event.stopPropagation()}
      >
        <h2>{title}</h2>
        {children}
      </div>
    </div>
  );
}
